/* eslint-disable jsx-a11y/alt-text */
import React, { memo } from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { Colors } from '../../constant/color';

type Props = {
  setAction: React.Dispatch<
    React.SetStateAction<{
      loading: boolean;
      payload: any;
      found?: any;
    }>
  >;
};

const NotFound = memo(({ setAction }: Props) => {
  const onSubmit = () => {
    setAction((e) => {
      return {
        ...e,
        loading: false,
        found: 'ADDITIONAL_DATA',
      };
    });
  };

  return (
    <Container>
      <div className="w-[400px] flex flex-col items-center">
        <div className="flex flex-col justify-center items-center">
          <img src={require('../../assets/no-entry.png')} />
          <div className="h-[20px]" />
          <div className='font-manrope font-bold text-[20px] leading-[1] tracking-normal"'>
            oopsie..
          </div>
          <div className="h-[20px]" />
          <div className="text-[#284495B0] font-manrope font-normal text-[16px] leading-[1] tracking-normal text-center">
            Харьцуулах автомашины мэдээлэл олдсонгүй.
          </div>
        </div>
        <div className="h-[30px]" />
        <Button color="blue" type="primary" size="large" onClick={onSubmit}>
          Үнэлгээчнээр үнэлүүлэх
        </Button>
      </div>
    </Container>
  );
});

const Container = styled.div`
  width: 800px;
  height: 800px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 100px;
  .ant-btn-color-primary {
    background-color: ${Colors.blue} !important;
  }
`;

NotFound.displayName = 'PageLoader';

export { NotFound };
